export function labelConvert(label: string): string {
  const temp = label
    .split(/(?=[A-Z])/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
  return temp.replaceAll("_", " ");
}
